import { render, staticRenderFns } from "./bold2.vue?vue&type=template&id=1baa5407&scoped=true&"
import script from "./bold2.vue?vue&type=script&lang=js&"
export * from "./bold2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa5407",
  null
  
)

export default component.exports